"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _partial = _interopRequireDefault(require("transmute/partial"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H7"));

var _QuestionEntityRecord = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/QuestionEntityRecord"));

var _PropertyQuickReplyInput = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/inputs/PropertyQuickReplyInput"));

function handleChange(onSubmissionChanged, onPropertyChanged, question, value) {
  var updatedQuestion = question.setValue(value);
  onSubmissionChanged(updatedQuestion);
  onPropertyChanged(updatedQuestion.getValueForObjectProperty());
}

var PropertyQuestionAndAnswerContent = function PropertyQuestionAndAnswerContent(_ref) {
  var question = _ref.question,
      tooltip = _ref.tooltip,
      disabled = _ref.disabled,
      objectProperty = _ref.objectProperty,
      onSubmissionChanged = _ref.onSubmissionChanged,
      onPropertyChanged = _ref.onPropertyChanged;

  if (!question.isPropertyQuickReply()) {
    return null;
  }

  if (!objectProperty) {
    return _react.default.createElement("div", null, _react.default.createElement(_FormattedMessage.default, {
      message: "composer-plugins.questionAndAnswer.propertyError",
      options: {
        propertyName: question.propertyName
      }
    }));
  }

  return _react.default.createElement(_UITooltip.default, {
    disabled: !tooltip,
    title: tooltip,
    placement: "left"
  }, _react.default.createElement("div", null, _react.default.createElement(_H.default, {
    className: "m-bottom-2"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "composer-plugins.questionAndAnswer.updatingProperty." + question.objectType,
    options: {
      property: objectProperty.get('label')
    }
  })), _react.default.createElement(_PropertyQuickReplyInput.default, {
    disabled: disabled,
    objectProperty: objectProperty,
    onChange: (0, _partial.default)(handleChange, onSubmissionChanged, onPropertyChanged, question),
    question: question
  })));
};

PropertyQuestionAndAnswerContent.propTypes = {
  question: _propTypes.default.instanceOf(_QuestionEntityRecord.default).isRequired,
  disabled: _propTypes.default.bool,
  tooltip: _propTypes.default.node,
  objectProperty: _propTypes.default.object,
  onSubmissionChanged: _propTypes.default.func,
  onPropertyChanged: _propTypes.default.func
};
PropertyQuestionAndAnswerContent.defaultProps = {
  onPropertyChanged: function onPropertyChanged() {
    return null;
  },
  onSubmissionChanged: function onSubmissionChanged() {
    return null;
  }
};
var _default = PropertyQuestionAndAnswerContent;
exports.default = _default;
module.exports = exports.default;